import {observer} from "mobx-react";
import {useStores} from "../../../Hooks";
import React from "react";
import PanoramaFishEyeIcon from '@mui/icons-material/PanoramaFishEye';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

const YesOrNoQuestion = observer(({question, index})=> {
    const {generalStore} = useStores();

    return (
        <>
            <div className="py-2 text-xs">{generalStore.translate('selectYourAnswer')}:</div>
            <div className="flex flex-row justify-between items-center gap-2">
                {['Yes', 'No'].map(option => (
                    <div
                        key={option}
                        style={{ flex: '1 1 0' }}
                        onClick={() =>{ question.BooleanValue = (option === 'Yes' ? true : false)}}
                        className={`h-11 rounded-xl outline outline-1 outline-panels-normal outline-offset-[-1px] flex items-center justify-center cursor-pointer flex flex-row gap-1 ${(question.BooleanValue === (option === 'Yes' ? true : false)) ?'bg-classic-button-normal text-classic-button-normal-text':'hover:bg-background-hover'}`}
                    >
                        {question.BooleanValue === (option === 'Yes' ? true : false) ?<CheckCircleOutlineIcon sx={{ fontSize: 20 }}/> :<PanoramaFishEyeIcon sx={{ fontSize: 20 }}/>}
                        <span className="text-sm font-normal leading-5 text-center font-sans">{generalStore.translate(option)}</span>
                    </div>
                ))}
            </div>
        </>
    );
});

export default YesOrNoQuestion;
